"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const message_dialog_1 = require("../message-dialog");
const DefaultOkButtonText = "OK";
class AlertDialog extends message_dialog_1.default {
    // CAUTION  never ever try to store any dynamic state in a
    // AlertDialog object since it is treated as immutable
    // Currently, solely ActiveModalDialog is known to be capable of
    // representing individual dialog instances.
    constructor(_alertDialogConfig = {}) {
        super(_alertDialogConfig); // call ModalDialog's constructor
        this._alertDialogConfig = _alertDialogConfig;
    }
    get okButtonSelector() {
        const selector = this._alertDialogConfig.okButtonSelector || ".ok-button";
        return `${this.footerSelector} ${selector}`;
    }
    get okButtonText() {
        return this._alertDialogConfig.okButtonText || DefaultOkButtonText;
    }
    get okCloseButton() {
        return "ok";
    }
    get cancelCloseButton() {
        return "ok";
    }
    getButtonMatcher() {
        return clickEvent => {
            if (this.jQuery(clickEvent.target).hasClass("ok-button")) {
                return this.okCloseButton;
            }
        };
    }
    toString() {
        return `Alert Dialog "${this.messageText}"`;
    }
    setContentVisibility(visible) {
        // show my modal buttons
        this.jQuery(this.okButtonSelector).text(visible ? this.okButtonText : DefaultOkButtonText);
        this.setVisibilityBySelector(this.okButtonSelector, visible);
        // show MessageDialog's stuff
        super.setContentVisibility(visible);
    }
}
exports.default = AlertDialog;
